import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as api from "./redirectApi";

export const fetchRedirects = createAsyncThunk("redirect/fetchRedirects", async (params, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getRedirects(params, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch redirects");
  }
});

export const createRedirect = createAsyncThunk("redirect/createRedirect", async (data, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.createRedirect(data, token);
    toast.success("Redirect created successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to create redirect";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const updateRedirect = createAsyncThunk("redirect/updateRedirect", async ({ id, data }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.updateRedirect(id, data, token);
    toast.success("Redirect updated successfully");
    return res.data;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to update redirect";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

export const deleteRedirect = createAsyncThunk("redirect/deleteRedirect", async (id, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    await api.deleteRedirect(id, token);
    toast.success("Redirect deleted successfully");
    return id;
  } catch (err) {
    const msg = err?.response?.data?.message || err?.message || "Failed to delete redirect";
    toast.error(msg);
    return rejectWithValue(msg);
  }
});

const redirectSlice = createSlice({
  name: "redirect",
  initialState: { redirects: [], total: 0, page: 1, pages: 0, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRedirects.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchRedirects.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload || {};
        state.redirects = payload.redirects || payload || [];
        state.total = payload.total || 0;
        state.page = payload.page || 1;
        state.pages = payload.pages || 0;
      })
      .addCase(fetchRedirects.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(createRedirect.fulfilled, (state, action) => {
        const r = action.payload?.redirect || action.payload;
        if (r?._id) state.redirects.unshift(r);
      })
      .addCase(createRedirect.rejected, (state, action) => { state.error = action.payload; })

      .addCase(updateRedirect.fulfilled, (state, action) => {
        const r = action.payload?.redirect || action.payload;
        if (r?._id) {
          const idx = state.redirects.findIndex((x) => x._id === r._id);
          if (idx !== -1) state.redirects[idx] = r;
        }
      })
      .addCase(updateRedirect.rejected, (state, action) => { state.error = action.payload; })

      .addCase(deleteRedirect.fulfilled, (state, action) => {
        state.redirects = state.redirects.filter((r) => r._id !== action.payload);
      })
      .addCase(deleteRedirect.rejected, (state, action) => { state.error = action.payload; });
  },
});

export default redirectSlice.reducer;
